module.exports = __webpack_public_path__ + "static/media/ma_programs.da61dbe4.jpg";